export const NUTRITION_OPTIONS = [
  { value: "high_protein", label: "High Protein", icon: "🥩", placeholder: "Optional quantity (e.g. 25g)" },
  { value: "high_fiber", label: "High Fiber", icon: "🌾", placeholder: "Optional quantity" },
  { value: "low_fat", label: "Low Fat", icon: "🍃", placeholder: "Optional quantity" },
  { value: "low_saturated_fat", label: "Low Saturated Fat", icon: "❤️", placeholder: "Optional quantity" },
  { value: "low_sodium", label: "Low Sodium", icon: "🧂", placeholder: "Optional quantity" },
  { value: "no_added_sugar", label: "No Added Sugar", icon: "🍬", placeholder: "Optional quantity" },
  { value: "sugar_free", label: "Sugar Free", icon: "🚫🍬", placeholder: "Optional quantity" },
  { value: "vegan", label: "Vegan", icon: "🌱", placeholder: "Optional quantity" },
  { value: "dairy_free", label: "Dairy Free", icon: "🥛", placeholder: "Optional quantity" },
  { value: "gluten_free", label: "Gluten Free", icon: "🌾🚫", placeholder: "Optional quantity" },
  { value: "organic", label: "Organic", icon: "🌿", placeholder: "Optional quantity" },
  { value: "low_calorie", label: "Low Calorie", icon: "⚡", placeholder: "Optional quantity (e.g. 120 kcal)" },
  { value: "rich_in_vitamins", label: "Rich in Vitamins", icon: "💪", placeholder: "Optional quantity" },
  { value: "source_of_healthy_fats", label: "Source of Healthy Fats", icon: "🥜", placeholder: "Optional quantity" },
  { value: "nutrient_dense", label: "Nutrient Dense", icon: "🌟", placeholder: "Optional quantity" },
  { value: "vegetarian", label: "Vegetarian", icon: "🥕", placeholder: "Optional quantity" },
  { value: "halal", label: "Halal", icon: "☪️", placeholder: "Optional quantity" },
  { value: "keto_friendly", label: "Keto Friendly", icon: "🥑", placeholder: "Optional quantity" },
  { value: "low_carb", label: "Low Carb", icon: "📉", placeholder: "Optional quantity" },
  { value: "nut_free", label: "Nut Free", icon: "🚫🥜", placeholder: "Optional quantity" },
  { value: "egg_free", label: "Egg Free", icon: "🚫🥚", placeholder: "Optional quantity" },
  { value: "lactose_free", label: "Lactose Free", icon: "🚫🧀", placeholder: "Optional quantity" },
  { value: "soy_free", label: "Soy Free", icon: "🫘", placeholder: "Optional quantity" },
  { value: "whole_grain", label: "Whole Grain", icon: "🍞", placeholder: "Optional quantity" },
  { value: "spicy", label: "Spicy", icon: "🌶️", placeholder: "Optional quantity (e.g. Mild, Hot)" },
  { value: "iron_rich", label: "Rich in Iron", icon: "🩸", placeholder: "Optional quantity" },
  { value: "high_calcium", label: "High Calcium", icon: "🦴", placeholder: "Optional quantity" },
  { value: "omega_3", label: "Omega-3", icon: "🐟", placeholder: "Optional quantity" },
  { value: "probiotic", label: "Probiotic", icon: "🦠", placeholder: "Optional quantity" },
  { value: "paleo", label: "Paleo Friendly", icon: "🍖", placeholder: "Optional quantity" },
];

export const VALID_NUTRITION_TYPES = NUTRITION_OPTIONS.map((option) => option.value);

export function getNutritionOption(type) {
  return NUTRITION_OPTIONS.find((option) => option.value === type) || NUTRITION_OPTIONS[0];
}

export function getNextNutritionType(existingValues) {
  const used = new Set((existingValues || []).map((item) => item?.type));
  const next = NUTRITION_OPTIONS.find((option) => !used.has(option.value));
  return next?.value || null;
}

export function normalizeNutritionValuesForSave(items) {
  const seen = new Set();

  return (Array.isArray(items) ? items : [])
    .filter((item) => VALID_NUTRITION_TYPES.includes(item?.type))
    .filter((item) => {
      if (seen.has(item.type)) return false;
      seen.add(item.type);
      return true;
    })
    .map((item) => ({
      type: item.type,
      value: String(item.value || "").trim(),
    }));
}
